var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.64937C0 4.18687 1.18688 3 2.64938 3C3.38063 3 4.07812 3.30188 4.57875 3.83438L6 5.34375L7.42125 3.83438C7.92188 3.30188 8.61938 3 9.35063 3C10.8131 3 12 4.18687 12 5.64937V6.35063C12 7.81313 10.8131 9 9.35063 9C8.61938 9 7.92188 8.69813 7.42125 8.16563L6 6.65625L4.57875 8.16563C4.07812 8.69813 3.38063 9 2.64938 9C1.18688 9 0 7.81313 0 6.35063V5.64937ZM5.38125 6L3.9225 4.45125C3.5925 4.10062 3.13125 3.9 2.6475 3.9C1.68187 3.9 0.898125 4.68375 0.898125 5.64937V6.35063C0.898125 7.31625 1.68187 8.1 2.6475 8.1C3.12937 8.1 3.59063 7.90125 3.9225 7.54875L5.38125 6ZM6.61688 6L8.07563 7.54875C8.40563 7.89938 8.86688 8.1 9.35063 8.1C10.3163 8.1 11.1 7.31625 11.1 6.35063V5.64937C11.1 4.68375 10.3163 3.9 9.35063 3.9C8.86875 3.9 8.4075 4.09875 8.07563 4.45125L6.61875 6H6.61688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityIcon);
export default __webpack_public_path__ + "static/media/infinity-icon.332476d372930c92e03cefc99867bdec.svg";
export { ForwardRef as ReactComponent };